/* eslint-disable import/no-unresolved */
import React, { createContext, useReducer } from 'react';
import PropTypes from 'prop-types';
import ContextDevTool from 'react-context-devtool';
import alertReducer, { initialState } from '../reducers/alertReducer';

export const AlertContext = createContext();

const AlertProvider = ({ children }) => {
  const useAlertState = useReducer(alertReducer, initialState);

  return (
    <AlertContext.Provider value={[...useAlertState]}>
      <ContextDevTool context={AlertContext} id="AlertContext" displayName="Alert Context" />
      {children}
    </AlertContext.Provider>
  );
};

AlertProvider.propTypes = {
  children: PropTypes.element.isRequired,
};

export default AlertProvider;
